import { Component, Input, Inject } from "@angular/core";

import { OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";

@Component({
  selector: "rm-confirm-dialog",
  templateUrl: "./confirm-dialog.component.html",
  styleUrls: ["./confirm-dialog.component.css"]
})
export class ConfirmationDialogComponent implements OnInit {
  defaultTitle: string = "Confirm";
  isFormValid: boolean = true;

  constructor(
    private dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {}

  ngOnInit() {}

  cancel() {
    this.dialogRef.close("no");
  }

  confirm() {
    this.dialogRef.close("yes");
  }
}

export interface DialogData {
  title: string;
  message: string;
  note: any;
}
